import styles from "./Filters.module.css"
import { useLocale, useTranslations } from "next-intl";
import GenresFilter from "./Genres/GenresFilter";
import LicenseFilter from "./License/LicenseFilter";
import MembershipFilter from "./Membership/MembershipFilter";
import SuggestionsFilter from "./Suggestions/SuggestionsFilter";
import { FilterState } from "../page";
import Button from "@/components/UI/Buttons/Button/Button";
import SupportedControlsFilter from "./SupportedControls/SupportedControlsFilter";
import { useMemberships } from "@/apiUtilities/queries/useMemberships";

export default function Filters({ update, resetSignal, initialFilters, filterCount, resetFilters }: {
	update: (name: string, value: string) => void,
	resetSignal: number,
	initialFilters: FilterState,
	filterCount: number,
	resetFilters: () => void
}) {
	const locale = useLocale()
	const { data: membershipsData } = useMemberships(locale)

	const t = useTranslations('Catalogue')
	return (
		<>
			<div className={styles.controls} data-testid="Filters">
				<h3 className={`${styles.filtersTitle} bodyTextLarge`} data-testid="Filters_title">{t('filtersTitle')}</h3>
				<div className={styles.resetWrapper} data-testid="Filters_resetWrapper">
					<Button data-testid="catalogueFilters_deleteFilters" disabled={filterCount === 0} onClick={resetFilters}>{t('deleteFilters')}</Button>
					{filterCount > 0 && <div className={styles.filterCounter} data-testid="Filters_count">{filterCount}</div>}
				</div>
			</div>

			<div className={styles.filtersWrapper}>
				<GenresFilter update={update} resetSignal={resetSignal} initialData={initialFilters.genres}/>
				<div className={styles.separator}></div>
				<SupportedControlsFilter update={update} resetSignal={resetSignal} initialData={initialFilters.supportedControls}/>
				<div className={styles.separator}></div>
				<SuggestionsFilter update={update} resetSignal={resetSignal} initialData={initialFilters}/>
				<div className={styles.separator}></div>
				{membershipsData && membershipsData.memberships.length > 1 && <MembershipFilter update={update} resetSignal={resetSignal} initialData={initialFilters.membership} />}
				{membershipsData && membershipsData.memberships.length > 1 && <div className={styles.separator}></div>}
				<LicenseFilter update={update} resetSignal={resetSignal} initialData={initialFilters.license}/>
			</div>
		</>

	)
}